import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  FormattedMessage,
  injectIntl,
  WrappedComponentProps,
} from 'react-intl';
import classNames from 'classnames';

import style from './LivePage.module.scss';

import LiveStore from 'stores/Live/LiveStore';

import RevenueReportSummary from 'components/Report/RevenueReport/ReportSummary/ReportSummary';
import RevenueReportTable from 'components/Report/RevenueReport/RevenueReportTable';
import Spinner from 'components/Spinner/Spinner';

@observer
class LivePage extends Component<WrappedComponentProps> {
  private _store = new LiveStore();

  async componentDidMount() {
    await this._store.init();
  }

  componentWillUnmount() {
    this._store.clearInterval();
  }

  render() {
    return <main className={style.main}>{this._renderReport()}</main>;
  }

  private _renderReport = () => {
    const { isInit, report } = this._store;

    if (!isInit) {
      return <Spinner contain />;
    }

    if (!report) {
      return (
        <div className={style.noReport}>
          <FormattedMessage id="error.404.explanation" />
        </div>
      );
    }

    return (
      <>
        <RevenueReportSummary values={report.total} />

        <div className={style.tables}>
          {report.categories.map(it => (
            <RevenueReportTable
              key={it.title}
              report={it}
              tableStyle={classNames({
                [style.table__single]: report.categories.length === 1,
              })}
            />
          ))}
        </div>
      </>
    );
  };
}

export default injectIntl(LivePage);
